import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

const ReservationViewSidebar = ({ isOpen, onClose, data, onEdit }) => {
  const navigate = useNavigate();

  if (!isOpen || !data) return null;

  const guest = data.full_reservation.guest || {};
  const room = data.full_reservation.room || {};
  const rate = data.full_reservation.rate_type || {};

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const clean = dateStr.replace("Z", "");
    const [datePart, timePart] = clean.split("T");
    const [year, month, day] = datePart.split("-");
    const [hour, minute] = timePart.split(":");
    const d = new Date(year, month - 1, day, hour, minute);
    return format(d, "dd MMM yyyy, hh:mm a");
  };

  return (
    <>
      <div className="right-sidebar-overlay open" onClick={onClose}></div>

      <div
        className="right-sidebar open bg-white shadow-lg"
        style={{
          width: "500px",
          right: 0,
          top: 0,
          bottom: 0,
          position: "fixed",
          zIndex: 2000,
          overflowY: "auto",
        }}
      >
        {/* HEADER */}
        <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-1">
              {guest.title} {guest.name}
            </h5>
            <div className="text-muted small">
              <i className="bi bi-telephone"></i> {guest.mobile_no} &nbsp;
              <i className="bi bi-envelope"></i> {guest.email}
            </div>
          </div>
          <CloseButton onClick={onClose} />
        </div>

        {/* ACTION BUTTONS */}
        <div className="p-3 d-flex gap-2 border-bottom">
          <Button
            variant="primary"
            onClick={() =>
              navigate(`/reservations/edit/${data.reservation_id}`)
            }
          >
            Edit Reservation
          </Button>
          {/* <Button variant="outline-secondary">More Options ▾</Button> */}
          {/* <Button variant="outline-secondary">Print ▾</Button> */}
        </div>

        {/* DETAILS */}
        <div className="p-3">
          <Row className="mb-3">
            <Col md={6}>
              <div className="text-muted small">Reservation Number</div>
              <div className="fw-semibold">
                {data.full_reservation.reservation_number}
              </div>
            </Col>
            <Col md={6}>
              <div className="text-muted small">Status</div>
              <div className="fw-semibold">
                {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <div className="text-muted small">Arrival Date</div>
              <div className="fw-semibold">{formatDateTime(data.check_in)}</div>
            </Col>
            <Col md={6}>
              <div className="text-muted small">Departure Date</div>
              <div className="fw-semibold">
                {formatDateTime(data.check_out)}
              </div>
            </Col>
          </Row>

          {data.full_reservation?.rooms.map((roomItem, index) => (
            <div key={index} className="mb-3 p-2 border rounded">
              <div className="fw-bold mb-2">Room {index + 1}</div>

              <Row className="mb-3">
                <Col md={6}>
                  <div className="text-muted small">Room Type</div>
                  <div className="fw-semibold">{roomItem.room_type_name}</div>
                </Col>
                <Col md={6}>
                  <div className="text-muted small">Room Number</div>
                  <div className="fw-semibold">
                    {roomItem.room?.room_number}
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <div className="text-muted small">Rate Plan</div>
                  <div className="fw-semibold">{roomItem.rate.name}</div>
                </Col>
                <Col md={6}>
                  <div className="text-muted small">Avg. Daily Rate</div>
                  <div className="fw-semibold">{roomItem.rate}</div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <div className="text-muted small">Adults</div>
                  <div className="fw-semibold">{roomItem.adults}</div>
                </Col>
                <Col md={6}>
                  <div className="text-muted small">Children</div>
                  <div className="fw-semibold">{roomItem.children}</div>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ReservationViewSidebar;
